module.exports = __webpack_public_path__ + "static/media/9_dedicatoria-min.322a8981.jpg";